import React, { useState } from 'react';
import { View } from 'react-native';
import { arrangeScreenInJson } from '../../../screens/ScreensOrdering';
import FullPagePanel from '../General/FullPagePanel';
import SwitcherPanel from '../Buttons/SwitcherPanel';
import {
  addPathToList, Android,
  enable_customers_go_menu,
  enable_customers_share_transaction,
  file_size_success,
  getSubCategoryId,
  Select_customize_fields,
  shareMethod, shareMethodKeys,
  Sharing_method,
  success_image_str,
  Transfer_success,
  Upload_assets,
} from '../../../utils/DictionaryManagementUtils';
import OpenBoxPanel from '../Buttons/OpenBoxPanel';
import { LocStr } from '../../../utils/Utils';
import UploadMenu from '../Upload/UploadMenu';

//= ========================================================================

const DefaultSuccess = ({
  globJSON,
  onConfigChanged,
  selectedScreen,
  onStepPressed,
  onGotoEdit,
  simPlatform,
  language,
}) => {
  const myScreen = globJSON.screens[selectedScreen];
  const subCategoryId = getSubCategoryId(myScreen);
  const { services } = globJSON.configurations;
  const { success } = services[subCategoryId];
  const { enable_customer_to_make_another_transfer } = success;
  const { enable_customer_to_share_transaction } = success;
  const editTextList = [
    'your_receipt',
    'share_in_chat',
    'share_receipt',
    'go_back_to_menu',
    'done',
    'copied_now_paste_to_chat',
    'share',
  ].filter((editText) => (services.menu.layout_menu_screen ? (editText !== 'done') : (editText !== 'go_back_to_menu')))
    .filter((editText) => ((editText === 'go_back_to_menu' || editText === 'done')
      ? enable_customer_to_make_another_transfer : enable_customer_to_share_transaction))
    .filter((editText) => ((editText === 'go_back_to_menu' || editText === 'done' || editText === 'share_receipt')
      ? true : success.sharing_method === 'receipt'))
    .filter((editText) => ((editText === 'copied_now_paste_to_chat' || editText === 'share') ? simPlatform !== Android : true))
    .filter((editText) => ((editText === 'share_in_chat') ? simPlatform === Android : true));

  const listObject = [
    {
      subHeadline: success_image_str,
      fileId: 'configurations/general/success_image',
    },

  ];
  const onValueChanged = (key, value) => {
    success[key] = value;
    arrangeScreenInJson(globJSON, onConfigChanged);
  };
  const [isBoxOpen, setBoxOpen] = useState(false);

  return (
    <FullPagePanel
      globJSON={globJSON}
      onConfigChanged={onConfigChanged}
      selectedScreen={selectedScreen}
      onStepPressed={onStepPressed}
      onGotoEdit={onGotoEdit}
      panelHeadline={Transfer_success}
      editTextList={addPathToList(editTextList, `configurations/services/${subCategoryId}/success/`)}
      tooltipsTitles={globJSON.configurations.services[subCategoryId].screens_ordering}
      disableEditElements={!enable_customer_to_share_transaction && !enable_customer_to_make_another_transfer}
      paragraph={Select_customize_fields}
      language={language}
    >
      <SwitcherPanel
        text={enable_customers_share_transaction}
        value={enable_customer_to_share_transaction}
        onValueChanged={(value) => {
          onValueChanged('enable_customer_to_share_transaction', value);
        }}
      />
      {enable_customer_to_share_transaction && (
        <View style={{ zIndex: 2 }}>
          <OpenBoxPanel
            language={language}
            isBoxOpen={isBoxOpen}
            text={LocStr(Sharing_method, language)}
            chosenValue={success.sharing_method}
            valuesMap={shareMethod}
            keysMap={shareMethodKeys}
            onPress={() => {
              setBoxOpen(!isBoxOpen);
            }}
            onValueChanged={(newSelection) => {
              success.sharing_method = newSelection;
              arrangeScreenInJson(globJSON, onConfigChanged);
            }}
            openBoxWidth={236}
            rightOffset={-46}
            checkImageLeft
          />
        </View>
      )}

      <SwitcherPanel
        text={enable_customers_go_menu}
        value={enable_customer_to_make_another_transfer}
        onValueChanged={(value) => {
          onValueChanged('enable_customer_to_make_another_transfer', value);
        }}
        marginTop={10}
      />
      <UploadMenu
        globJSON={globJSON}
        onConfigChanged={onConfigChanged}
        headline={Upload_assets}
        details={file_size_success}
        listObject={listObject}
      />
    </FullPagePanel>
  );
};

export default DefaultSuccess;
